import { putRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const cancelBooking = async (jobId, payload) => {
  try {
    return await putRequest(urls.CANCEL_BOOKING + `/${jobId}`, payload);
  } catch (err) {
    return err;
  }
};
